export default __webpack_public_path__ + "static/avatar-tag-anatomy-light-4ab5422f5adba57a75b07d4a292c9d434769cc7396fb1fb98f5c24e2261f62d0.png";